type ElementSelector = {
  selector: string;
};

export class SvcDataTableSettings {
  public parentScrollElement: ElementSelector | (() => HTMLElement);
}
